export class ReleaseInfo {
  constructor (title, version, date) {
    this.title = title;
    this.version = version;
    this.date = date;
  }
}